import { FETCH_BILL_ENTRY_REPORTS_DATA_FAILURE, FETCH_BILL_ENTRY_REPORTS_DATA_REQUEST, FETCH_BILL_ENTRY_REPORTS_DATA_SUCCESS, FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_FAILURE, FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_REQUEST, FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_SUCCESS, FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_FAILURE, FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_REQUEST, FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_SUCCESS, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_FAILURE, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_REQUEST, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_SUCCESS, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_FAILURE, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_REQUEST, FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_SUCCESS, FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_FAILURE, FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_REQUEST, FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_SUCCESS, SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_DK } from "./billEntryReport.actionsType";


export const BILL_ENTRY_REPORT = 'billreports';

let initialState = {
    loading: false,
    billreportData: [],
    styleMasterMainList: [],
    renderGridBtn: 'summaryGrid',
    billEntryReportDetail: [],
    billEntryReportConsolidate: [],
    billEntryReportConsolidateDetail: [],
    billentryDebitOrCreditData: []
};

export let billEntryReports = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_ENTRY_REPORTS_DATA_REQUEST:
        case FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_REQUEST:
        case FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_REQUEST:
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_REQUEST:
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_REQUEST:
        case FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BILL_ENTRY_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billreportData: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterMainList: updatePayload
            };
        case FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                billEntryReportDetail: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                billEntryReportConsolidate: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                billEntryReportConsolidateDetail: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                billentryDebitOrCreditData: updatePayload
            };
        case FETCH_BILL_ENTRY_REPORTS_DATA_FAILURE:
        case FETCH_BILL_ENTRY_REPORTS_STYLE_WISE_FAILURE:
        case FETCH_BILL_ENTRY_REPORT_DETAIL_REPORT_FAILURE:
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_REPORT_FAILURE:
        case FETCH_BILL_ENTRY_REPORT_CONSOLIDATE_DETAIL_REPORT_FAILURE:
        case FETCH_BILL_ENTRY_REPORTS_WITH_DEBIT_OR_CREDIT_FAILURE:
            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_DK:
            return {
                ...state,
                renderGridBtn: payload
            };

        default:
            return state;
    }
};